export default "__VITE_ASSET__Ln9Dma$b__"